/**
 * FocusAreas Component
 * Displays target industries and sectors
 */

import { FOCUS_AREAS } from '../utils/constants';

export function createFocusAreas(): string {
  return `
    <!-- ════════════════════════════════════
         FOCUS AREAS
    ════════════════════════════════════ -->
    <section id="focus-areas" style="background:#000000; position:relative; overflow:hidden;">

      <!-- Decorative gold circle -->
      <div style="position:absolute; left:-100px; bottom:-100px; width:400px; height:400px; border:1px solid rgba(201, 162, 39, 0.05); border-radius:50%; pointer-events:none;"></div>

      <div style="max-width:1320px; margin:0 auto; padding:0 48px; position:relative; z-index:1;">

        <div style="text-align:center; max-width:800px; margin:0 auto 72px;">
          <div class="reveal" style="display:flex; justify-content:center; align-items:center; gap:18px; margin-bottom:32px;">
            <span class="gold-rule"></span>
            <span class="eyebrow">Focus Areas</span>
            <span class="gold-rule"></span>
          </div>
          <h2 class="reveal d1" style="
            font-family:'Cormorant Garamond',serif;
            font-size:clamp(44px, 4.8vw, 64px);
            font-weight:500;
            line-height:1.15;
            color:#F8F7F4;">
            Concentrated Expertise Across <br> <span style="color:#C9A227;">Core Areas</span>
          </h2>
        </div>

        <div class="focus-areas-grid" style="display:grid; grid-template-columns: repeat(2, 1fr); gap:32px;">
          ${FOCUS_AREAS.map((area, index) => `
            <div class="reveal focus-area-card d${(index % 2) + 1} glass" style="padding:40px; border-radius:12px; border:1px solid rgba(201, 162, 39, 0.1); background: rgba(255,255,255,0.02); display:flex; gap:28px; transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);"
              onmouseover="this.style.borderColor='rgba(201, 162, 39, 0.3)'; this.style.background='rgba(201, 162, 39, 0.05)'; this.style.transform='translateY(-8px)';"
              onmouseout="this.style.borderColor='rgba(201, 162, 39, 0.1)'; this.style.background='rgba(255, 255, 255, 0.02)'; this.style.transform='translateY(0)';" class="glass">
              <div class="focus-area-icon" style="flex-shrink:0; width:56px; height:56px; display:flex; align-items:center; justify-content:center; background:#111009; border-radius:12px; color:#C9A227; box-shadow: 0 8px 20px rgba(0,0,0,0.3); border:1px solid rgba(201, 162, 39, 0.15);">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div>
                <h3 style="
                  font-family:'Cormorant Garamond',serif;
                  font-size:32px;
                  font-weight:600;
                  color:#F8F7F4;
                  margin-bottom:12px;">
                  ${area.title}
                </h3>
                <p style="
                  font-family:'Inter',sans-serif;
                  font-size:16px;
                  line-height:1.75;
                  color:rgba(248,247,244,0.45);">
                  ${area.description}
                </p>
              </div>
            </div>
          `).join('')}
        </div>

        <!-- Partnership CTA in Focus Areas -->
        <div class="reveal d3" style="margin-top:72px; text-align:center;">
          <p style="font-family:'Inter',sans-serif; font-size:17px; color:rgba(248,247,244,0.35); margin-bottom:28px; font-weight:300;">
            We pursue concentrated strategic expertise where our operational network creates a structural advantage.
          </p>
          <a href="/contact.html" class="gold-shine" style="font-family:'Inter',sans-serif; font-size:16px; font-weight:600; color:#F8F7F4; text-decoration:none; display:inline-flex; align-items:center; gap:12px; border-bottom:1px solid #C9A227; padding-bottom:4px; transition:all 0.4s ease;"
            onmouseover="this.style.gap='20px'; this.style.color='#C9A227';"
            onmouseout="this.style.gap='12px'; this.style.color='#F8F7F4';">
            Contact Our Team
            <svg width="16" height="11" viewBox="0 0 14 9" fill="none">
              <path d="M1 4.5H13M9 1L13 4.5L9 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>

      </div>
    </section>
  `;
}

export default createFocusAreas;
